import { Container, Content } from "./style";
import Ecosystem1 from "../../../../assets/img/Langding/Ecosystem1.png";
import Ecosystem2 from "../../../../assets/img/Langding/Ecosystem2.png";
import Ecosystem3 from "../../../../assets/img/Langding/Ecosystem3.png";
import Ecosystem4 from "../../../../assets/img/Langding/Ecosystem4.png";
import Ecosystem5 from "../../../../assets/img/Langding/Ecosystem5.png";
import Ecosystem6 from "../../../../assets/img/Langding/Ecosystem6.png";

const Ecosystem = () => {
  return (
    <Container>
      <h1>Our Ecosystem Partners</h1>
      <Content>
        <img src={Ecosystem1} alt="" />
        <img src={Ecosystem2} alt="" />
        <img src={Ecosystem3} alt="" />
        <img src={Ecosystem4} alt="" />
        <img src={Ecosystem5} alt="" />
        <a
          href="https://skyharbor.certik.com/shared-report/9cb0cbb6-c58a-4b22-a726-6d0f0859c87b"
          target="_blank"
        >
          <img src={Ecosystem6} alt="" />
        </a>
      </Content>
    </Container>
  );
};
export default Ecosystem;
